import { useCookies } from "react-cookie";
import { deleteFromFavourites } from "../../../services/meals";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Favourite({
  favourite,
  cart,
  setCart,
  setShowMessage,
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [cookie] = useCookies(["access_token"]);
  const [hide, setHide] = useState(false);

  const [priceBGN, setPriceBGN] = useState(null);

  useEffect(() => {
    if (!favourite?.price) return;

    setPriceBGN((Number(favourite.price) * 1.95583).toFixed(2));
  }, [favourite]);
  return (
    <div className={hide ? "hide favourite" : "favourite"}>
      <div className="favourite-wrap">
        <div
          className="image"
          onClick={() => navigate(`/menu/product/${favourite.id}`)}
        >
          {favourite?.images?.length > 0 ? (
            <img src={favourite.images[0]?.url} alt={favourite?.name} />
          ) : (
            <img
              src="https://alexfish-static.s3.eu-north-1.amazonaws.com/missing.svg"
              alt="Not found"
            />
          )}
        </div>
        <div className="info">
          <div className="favourite-title">
            <div
              className="name"
              onClick={() => navigate(`/menu/product/${favourite.id}`)}
            >
              <p>{favourite?.name ? favourite.name : ""}</p>
            </div>
            <div className="price">
              <p>
                {favourite?.price ? favourite.price : ""}€/
                {priceBGN !== null ? priceBGN + t("lv") : "Converting..."}
              </p>
            </div>
          </div>
          <div className="description">
            <p>{favourite?.description ? favourite.description : ""}</p>
          </div>
          {window.screen.width > 767 && (
            <div className="buttons">
              <button
                className="border"
                onClick={() => {
                  favourite?.id &&
                    deleteFromFavourites(
                      Number(favourite.id),
                      cookie.access_token,
                    ).then(() => setHide(true));
                }}
              >
                {t("delete")}
              </button>
              <button
                className="add"
                onClick={() => {
                  if (typeof window.gtag === "function") {
                    window.gtag("event", "add_to_cart", {
                      currency: "EUR",
                      value: favourite?.price,
                      items: [favourite],
                    });
                  } else {
                    console.error("gtag is not defined!");
                  }
                  setShowMessage(true);
                  setCart([
                    ...cart,
                    { ...favourite, amount: 1, singlePrice: favourite?.price },
                  ]);
                }}
              >
                {t("add")}
              </button>
            </div>
          )}
        </div>
      </div>
      {window.screen.width <= 767 && (
        <div className="buttons">
          <button
            className="border"
            onClick={() => {
              favourite?.id &&
                deleteFromFavourites(
                  Number(favourite.id),
                  cookie.access_token,
                ).then(() => setHide(true));
            }}
          >
            Изтрий
          </button>
          <button
            className="add"
            onClick={() => {
              if (typeof window.gtag === "function") {
                window.gtag("event", "add_to_cart", {
                  currency: "EUR",
                  value: favourite?.price,
                  items: [favourite],
                });
              } else {
                console.error("gtag is not defined!");
              }
              setShowMessage(true);
              setCart([
                ...cart,
                { ...favourite, amount: 1, singlePrice: favourite?.price },
              ]);
            }}
          >
            {t("add")}
          </button>
        </div>
      )}
    </div>
  );
}
